import React from 'react'
import { Provider } from 'react-redux'
import { LocaleProvider } from 'antd'
import ptPT from 'antd/lib/locale-provider/pt_BR'
import App from './App'

const Root = ({ store }) => (
    <Provider store={store}>
        <LocaleProvider locale={ptPT}>
            <App />
        </LocaleProvider>
    </Provider>
)

export default Root



// WEBPACK FOOTER //
// ./src/containers/Root.js